import { render, staticRenderFns } from "./ProductIntroIcon.vue?vue&type=template&id=0fd00e1c&scoped=true"
import script from "./ProductIntroIcon.vue?vue&type=script&lang=js"
export * from "./ProductIntroIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd00e1c",
  null
  
)

export default component.exports